import React from 'react'
import styled from '@emotion/styled'
import { wrap as withStyle, themeColor } from 'utils/styles'
import { Icon } from 'components/patterns'
import CardList from 'components/CardList'
import Modal from 'components/patterns/Modal'

export default withStyle(
  () => `
    .ant-modal-body {
      padding: 0px !important;
    }
  `
)

// PBI 147363 - Documentation 9: Styled modal for Update Switches
export const StyledReplaceSwitchModal = styled(Modal)`
  &&& {
    top: 10vh;
  }
  &&& {
    .ant-modal-content {
      display: flex;
      flex-direction: column;
      max-height: 80vh;
      height: 80vh;
    }
    .ant-modal-body {
      padding: 0;
      display: flex;
      flex-direction: column;
      flex: 1;
      min-height: 0;
      overflow: hidden;
    }
    .ant-modal-header {
      padding: 0;
      width: 100%;
      flex-shrink: 0;
    }
    .ant-modal-title {
      display: block;
      width: 100%;
    }
    .ant-modal-footer {
      display: flex;
      height: 72px;
      padding: 0 25px;
      justify-content: flex-end;
      align-items: center;
      gap: 16px;
      align-self: stretch;
      border-radius: 0 0 3px 3px;
      border-top: 1px solid #e3e5e8;
      background: #fff;
      box-sizing: border-box;

      .ant-btn {
        margin: 0;
      }
    }
  }
`

export const ModalContent = styled.div`
  padding: 0px !important;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  &&.ant-modal-body {
    padding: 0px !important;
  }
`

export const ModalContainer = styled.div`
  display: flex;
  flex: 1;
  min-height: 0;
`

// PBI 147363 - Documentation 9: Header container with link icon
export const HeaderContainer = styled.div`
  display: flex;
  width: 100%;
  padding: 16px 25px;
  align-items: center;
  border-radius: 3px 3px 0 0;
  border-bottom: 1px solid #e3e5e8;
  background: #fff;
  box-sizing: border-box;
`

export const HeaderTitle = styled.h2`
  color: rgba(7, 7, 15, 0.87);
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin: 0;
`

export const HeaderLinkIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    style={{ flexShrink: 0, marginRight: 15 }}
  >
    <path
      d="M12.7583 7.24184C15.0922 9.57813 15.0601 13.3238 12.7724 15.6242C12.7681 15.6289 12.763 15.634 12.7583 15.6387L10.1333 18.2637C7.81807 20.5789 4.05131 20.5786 1.73643 18.2637C-0.578809 15.9489 -0.578809 12.1817 1.73643 9.86684L3.18588 8.41739C3.57026 8.03301 4.23221 8.28848 4.25205 8.83168C4.27736 9.52395 4.40151 10.2195 4.63057 10.8911C4.70815 11.1185 4.65272 11.3701 4.48279 11.54L3.97158 12.0512C2.87682 13.146 2.84248 14.9285 3.92647 16.034C5.02115 17.1504 6.82045 17.157 7.92354 16.0539L10.5485 13.4293C11.6497 12.3281 11.6451 10.5482 10.5485 9.4516C10.404 9.30731 10.2583 9.1952 10.1446 9.11688C10.0641 9.06162 9.99768 8.98832 9.95056 8.90282C9.90345 8.81733 9.87696 8.722 9.87323 8.62446C9.85776 8.21168 10.004 7.78633 10.3302 7.46016L11.1526 6.6377C11.3683 6.42204 11.7066 6.39555 11.9567 6.57009C12.2431 6.77007 12.5113 6.99485 12.7583 7.24184ZM18.2636 1.73631C15.9487 -0.578612 12.1819 -0.578925 9.8667 1.73631L7.2417 4.3613C7.23701 4.36599 7.23194 4.37107 7.22764 4.37575C4.9399 6.67622 4.90783 10.4219 7.2417 12.7582C7.48869 13.0051 7.75692 13.2299 8.0433 13.4299C8.29338 13.6044 8.63174 13.5779 8.84737 13.3623L9.66979 12.5398C9.99596 12.2136 10.1422 11.7883 10.1267 11.3755C10.123 11.278 10.0965 11.1826 10.0494 11.0971C10.0023 11.0116 9.93585 10.9383 9.85537 10.8831C9.74162 10.8048 9.596 10.6927 9.45143 10.5484C8.35483 9.45176 8.35022 7.67184 9.45143 6.57063L12.0764 3.94603C13.1795 2.84294 14.9788 2.84958 16.0735 3.96595C17.1575 5.07142 17.1232 6.85399 16.0284 7.94875L15.5172 8.45996C15.3473 8.62989 15.2918 8.88145 15.3694 9.10887C15.5985 9.78051 15.7226 10.476 15.7479 11.1683C15.7678 11.7115 16.4297 11.9669 16.8141 11.5826L18.2635 10.1331C20.5788 7.81832 20.5788 4.05114 18.2636 1.73631Z"
      fill="#4F5764"
      fillOpacity="0.87"
    />
  </svg>
)

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  flex-shrink: 0;

  &:hover {
    opacity: 0.7;
  }
`

export const CloseIcon = styled(Icon)`
  &&& {
    width: 14px;
    height: 14px;
    fill: rgba(79, 87, 100, 0.87);
  }
`

// PBI 147363 - Documentation 9: Switch list container (main content area)
export const SwitchListContainer = styled.div`
  flex: 1;
  padding: 25px 0px 25px 25px;
  overflow-y: auto;
  min-height: 0;
  background: ${themeColor('modalGrey')};
  scrollbar-width: thin;
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }

  .ant-col {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
`

// PBI 147363 - Documentation 9: Side menu for signal tiles
export const SideMenu = styled(CardList)`
  display: flex;
  flex-direction: column;
  width: 280px;
  align-items: flex-start;
  align-self: stretch;
  border-left: 1px solid #e3e5e8;
  background: #fff;
  overflow-y: auto;

  & > div {
    width: 100%;
    flex-shrink: 0;
    min-height: 94px !important;
    height: auto !important;

    > div:first-of-type {
      top: 0 !important;
      bottom: 0 !important;
      height: auto !important;
    }
  }
`

// PBI 147363 - Documentation 9: Signal name header in side panel tile
export const SignalNameHeader = styled.div`
  align-self: stretch;
  color: rgba(7, 7, 15, 0.87);
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px;
  margin-bottom: 4px;
`

export const SignalInfoText = styled.span`
  align-self: stretch;
  color: rgba(7, 7, 15, 0.7);
  font-family: Arial, sans-serif;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`

// PBI 147363 - Documentation 9: Warning message container
export const WarningContainer = styled.div`
  margin-top: 4px;
  font-size: 14px;
  display: flex;
  align-items: center;
`

export const WarningText = styled.span`
  flex: 1 0 0;
  color: rgba(7, 7, 15, 0.7);
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`

// PBI 147363 - Documentation 9: Warning icon (yellow triangle)
export const WarningAlertIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="18"
    viewBox="0 0 20 18"
    fill="none"
    style={{ marginRight: 5, flexShrink: 0 }}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.7154 14.8189L11.833 1.05409C11.65 0.733897 11.3854 0.467745 11.0661 0.282625C10.7469 0.0975043 10.3843 0 10.0151 0C9.64596 0 9.28337 0.0975043 8.96411 0.282625C8.64486 0.467745 8.38029 0.733897 8.19725 1.05409L0.284762 14.8189C0.100228 15.1379 0.0020951 15.4995 3.31778e-05 15.8679C-0.00202875 16.2363 0.0920503 16.599 0.273001 16.92C0.453952 17.2411 0.715533 17.5095 1.03197 17.6989C1.34841 17.8883 1.70878 17.9921 2.07759 18H17.9026C18.2731 17.9955 18.636 17.8942 18.9552 17.7062C19.2743 17.5182 19.5387 17.2501 19.722 16.9285C19.9053 16.6068 20.0011 16.2429 20 15.8728C19.9988 15.5027 19.9007 15.1394 19.7154 14.8189ZM10.9917 14.4988H8.9885V12.4981H10.9917V14.4988ZM10.9917 9.49703C10.9917 9.76234 10.8861 10.0168 10.6983 10.2044C10.5105 10.392 10.2557 10.4974 9.99009 10.4974C9.72445 10.4974 9.46969 10.392 9.28186 10.2044C9.09402 10.0168 8.9885 9.76234 8.9885 9.49703V7.49634C8.9885 7.23103 9.09402 6.97658 9.28186 6.78898C9.46969 6.60138 9.72445 6.49599 9.99009 6.49599C10.2557 6.49599 10.5105 6.60138 10.6983 6.78898C10.8861 6.97658 10.9917 7.23103 10.9917 7.49634V9.49703Z"
      fill="#EFB115"
    />
    <path d="M10.9917 12.4981H8.9885V14.4988H10.9917V12.4981Z" fill="#07070F" />
    <path
      d="M10.9917 9.49703V7.49634C10.9917 7.23103 10.8861 6.97658 10.6983 6.78898C10.5105 6.60138 10.2557 6.49599 9.99009 6.49599C9.72445 6.49599 9.46969 6.60138 9.28186 6.78898C9.09402 6.97658 8.9885 7.23103 8.9885 7.49634V9.49703C8.9885 9.76234 9.09402 10.0168 9.28186 10.2044C9.46969 10.392 9.72445 10.4974 9.99009 10.4974C10.2557 10.4974 10.5105 10.392 10.6983 10.2044C10.8861 10.0168 10.9917 9.76234 10.9917 9.49703Z"
      fill="#07070F"
    />
  </svg>
)

// PBI 147363 - Documentation 9: Empty state
export const EmptyState = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: ${themeColor('blackSecondary')};
`

// PBI 147363 - Documentation 10: Selected switch container (same layout as warning)
export const SelectedSwitchContainer = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: center;
`

// PBI 147363 - Documentation 10: Selected switch text (description)
export const SelectedSwitchText = styled.span`
  flex: 1 0 0;
  color: rgba(7, 7, 15, 0.7);
  font-family: Arial, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`

// PBI 147363 - Documentation 10: Green checkmark icon for selected state
export const SelectedCheckIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="15"
    viewBox="0 0 20 15"
    fill="none"
    style={{ marginRight: 5, flexShrink: 0 }}
  >
    <path
      d="M3.53727 6.04772C2.76065 5.26226 1.50151 5.26226 0.724893 6.04772L0.582462 6.19177C-0.194154 6.97723 -0.194154 8.2507 0.582462 9.03616L5.71734 14.2295C5.72878 14.2416 5.74039 14.2537 5.75219 14.2656L5.89462 14.4097C6.15036 14.6683 6.45843 14.8418 6.78436 14.9301C7.44849 15.1105 8.187 14.9371 8.70818 14.41L8.85061 14.2659C8.86614 14.2502 8.88135 14.2343 8.89625 14.2183L19.4172 3.57753C20.1938 2.79208 20.1938 1.5186 19.4172 0.733144L19.2748 0.589091C18.4982 -0.196365 17.239 -0.196364 16.4624 0.589093L7.30124 9.85454L3.53727 6.04772Z"
      fill="#30A621"
    />
  </svg>
)
